import { threeDotSeparator } from './index';
import { t } from '../i18n';

export const EVIDENCE_TYPE = {
  PRACTICE_KNOWLEDGE: 1,
  ACADEMIC_LITERATURE: 2,
  DATA_LEGACY: 3, // deactivated — but if in system can edit-only
  REPORTS_GREY_LITERATURE: 4,
  OTHER_MEDIA: 5,
};

export const TITLE_REQUIRED_TYPES = [1, 2, 4, 5];
export const AUTHOR_REQUIRED_TYPES = [1]; // auto-filled to the current user for Practice Knowledge
export const YEAR_REQUIRED_TYPES = [1, 2, 4, 5];
export const MATERIAL_TYPE_REQUIRED_TYPES = [2, 4, 5]; // Practice Knowledge has no material type field

// TAK-2110 - let's take this requirement out for now
export const LINK_REQUIRED_TYPES = [];
// export const LINK_REQUIRED_TYPES = [5]; // 'Other Media' isn't verifiable without a link... i think thats reasonable??

export const EVIDENCE_TYPE_FIELD_CONFIG = {
  [EVIDENCE_TYPE.PRACTICE_KNOWLEDGE]: {
    icon: 'lightbulb outline',
    showTitle: true,
    showAuthor: true,
    showYear: true,
    showMaterialType: false,
    showDoi: false,
    showLink: false,
    contentLabel: t('evidence_types.practice_knowledge.content.label'),
    contentPlaceholder: t(
      'evidence_types.practice_knowledge.content.placeholder'
    ),
  },
  [EVIDENCE_TYPE.ACADEMIC_LITERATURE]: {
    icon: 'graduation cap',
    showTitle: true,
    showAuthor: true,
    showYear: true,
    showMaterialType: true,
    showDoi: true,
    showLink: true,
    contentLabel: t('evidence_types.academic_literature.content.label'),
    contentPlaceholder: t(
      'evidence_types.academic_literature.content.placeholder'
    ),
  },
  [EVIDENCE_TYPE.REPORTS_GREY_LITERATURE]: {
    icon: 'university',
    showTitle: true,
    showAuthor: true,
    showYear: true,
    showMaterialType: true,
    showDoi: true,
    showLink: true,
    showVisibilityToggle: true, // can reference unreleased/internal docs — opt-in only for the All Takso library
    contentLabel: t('evidence_types.grey_literature.content.label'),
    contentPlaceholder: t('evidence_types.grey_literature.content.placeholder'),
  },
  [EVIDENCE_TYPE.OTHER_MEDIA]: {
    icon: 'newspaper outline',
    showTitle: true,
    showAuthor: true,
    showYear: true,
    showMaterialType: true,
    showDoi: false,
    showLink: true,
    contentLabel: t('evidence_types.other_media.content.label'),
    contentPlaceholder: t('evidence_types.other_media.content.placeholder'),
  },
};

export function isLegacyDataType(evidenceTypeId) {
  return Number(evidenceTypeId) === EVIDENCE_TYPE.DATA_LEGACY;
}

// Evidence created before Aug 2026- doesnt have a title...
export function getEvidenceDisplayTitle(item, length = 60) {
  if (item.title) return item.title;
  return item.content
    ? threeDotSeparator({ name: item.content, length, isPopUp: false })
    : t('common.untitled');
}

// Evidence created before the Aug 2026 structured-fields migration only has
// the old freeform `source` citation string — title/author were never
// backfilled onto it. Fall back to `source` so that citation info doesn't
// just disappear from the library card.
export function getEvidenceAttributionLine(item) {
  if (item.author) return item.author;
  if (!item.title && item.source) return item.source;
  return null;
}

// "Evidence type: material type" (e.g. "Other Media: Social Media Post") fallback to (Practice Knowledge has none).
export function getEvidenceTypeLine(item) {
  return [
    item.evidenceTypeData && item.evidenceTypeData.evidenceType,
    item.materialTypeData && item.materialTypeData.name,
  ]
    .filter(Boolean)
    .join(': ');
}
